import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    paginationContainer: {
      padding: "32px 0 0 0",
      display: 'flex',
      flex:1,
      flexDirection: 'column',
      width:'100%',
    },
    numberContainer:{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',

    },

    arrowItem: {
      cursor: 'pointer',
      borderRadius: '6px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    disable: {
      cursor: 'default',
      pointerEvents:'none'
    }

  };
});
